import { FC } from "react";

const Settings: FC = () => {
    return (
        <>
            
        </>
    )
}

export default Settings;